import React, { useState, useRef, useEffect } from "react";
import NewCompanyModal from "../../Templates/NewProject/Parts/NewCompanyModal";

const comboBoxStyles = {
  container: {
    position: "relative",
    color: "#fff",
    padding: "10px",
    borderRadius: "6px",
  },
  input: {
    width: "100%",
    backgroundColor: "transparent",
    color: "#ccc",
    padding: "12px",
    border: "1px solid #314158",
    borderRadius: "8px",
    fontSize: "14px",
    outline: "none",
  },
  label: {
    fontSize: "14px",
    color: "#e1e1e1",
    fontWeight: "400",
    marginBottom: '3px'
  },
  dropdown: {
    position: "absolute",
    top: "105%",
    left: 0,
    right: 0,
    backgroundColor: "#1e1e1e",
    border: "1px solid #314158",
    borderRadius: "8px",
    marginTop: "4px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
    zIndex: 100,
    maxHeight: "0px",
    opacity: 0,
    transition: "max-height 0.3s ease, opacity 0.3s ease",
    overflowY: "auto",
  },
  dropdownOpen: {
    maxHeight: "180px",
    opacity: 1,
  },
  item: {
    padding: "10px 14px",
    cursor: "pointer",
    fontSize: "15px",
    color: "#fff",
  },
  fixedItem: {
    width: '100%',
    padding: "10px 14px",
    cursor: "pointer",
    fontSize: "15px",
    color: "#fff",
    borderTop: '1px solid #314158'
  },
  itemHover: {
    backgroundColor: "#333",
  },
};

const CompanyComboBox = ({ items, label, mandatory, placeholder, onSelect, value, selectedCompanyId, onCompanyCreated }) => {
  const [inputValue, setInputValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [hovered, setHovered] = useState(null);
  const [filteredItems, setFilteredItems] = useState(items);
  const [newCompanyModalOpen, setNewCompanyModalOpen] = useState(false);
  const [isTyping, setIsTyping] = useState(false);

  const dropdownRef = useRef(null);

  const selectedCompany = items.find(item => item.id === selectedCompanyId);
  
  const displayValue = isTyping ? inputValue : (selectedCompany ? selectedCompany.name : inputValue);

  useEffect(() => {
    setFilteredItems(
      items.filter((item) => 
        item.name.toLowerCase().includes(inputValue.toLowerCase())
      )
    );
  }, [inputValue, items]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
        setIsTyping(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (company) => {
    setInputValue(company.name);
    setIsOpen(false);
    setIsTyping(false);
    if (onSelect) onSelect(company);
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    setIsTyping(true);
    setIsOpen(true);
  };

  const handleInputFocus = () => {
    setIsOpen(true);
    setIsTyping(true);
  };

  return (
    <>
      <NewCompanyModal
        isOpen={newCompanyModalOpen}
        onClose={() => setNewCompanyModalOpen(false)}
        onCompanyCreated={onCompanyCreated}
      />
      <div style={comboBoxStyles.container} ref={dropdownRef}>
        {label && (<label style={comboBoxStyles.label}>{mandatory ? label + " *" : label}</label>)}

        <input
          type="text"
          style={comboBoxStyles.input}
          placeholder={placeholder || "Digite ou selecione..."}
          value={displayValue}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
        />
        <div
          style={{
            ...comboBoxStyles.dropdown,
            ...(isOpen ? comboBoxStyles.dropdownOpen : {}),
          }}
        >
          {filteredItems.length > 0 ? (
            filteredItems.map((company, index) => (
              <div
                key={company.id}
                style={{
                  ...comboBoxStyles.item,
                  ...(hovered === index ? comboBoxStyles.itemHover : {}),
                }}
                onMouseEnter={() => setHovered(index)}
                onMouseLeave={() => setHovered(null)}
                onClick={() => handleSelect(company)}
              >
                {company.name}
              </div>
            ))
          ) : (
            <div style={{ ...comboBoxStyles.item, color: "#888" }}>
              Nenhum item encontrado
            </div>
          )}
          <div style={comboBoxStyles.fixedItem}>
            <button
              className="btn"
              onClick={() => setNewCompanyModalOpen(true)}
            >
              +  Adicionar nova empresa
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyComboBox;